/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import styles from './styles.module.scss';
import { View, Icon, Text } from '@az/starc-ui';
import { CheckmarkCircle } from '@az/starc-ui-icons';

const labelMap = {
  recommended: 'label_reviews_recommended',
};

export const Recommended = () => {
  const labels = useLabels(labelMap);

  return (
    <View className={styles.badgeContainer}>
      <Icon svg={CheckmarkCircle} color="success" size={{ s: 3.75, m: 4 }} />
      <Text variant="small-body" weight="bold">
        {labels.recommended}
      </Text>
    </View>
  );
};
